import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fabf177"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outside-container position-relative w-100" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  id: "timeline-entry-container",
  class: "d-flex align-items-center timeline-container position-relative"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "horizontal-line" }, null, -1))
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TimelineEntry = _resolveComponent("TimelineEntry")!
  const _component_WdwDynbox = _resolveComponent("WdwDynbox")!

  return (_openBlock(), _createBlock(_component_WdwDynbox, {
    titlefontsize: "1.3rem",
    title: _ctx.hidetitle ? '' : _ctx.timeline.title,
    minimize: false,
    config: { showControls: true }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          disabled: _ctx.showleft,
          class: "btn btn-secondary move-timeline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchLeft()))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'angle-left'] })
        ], 8, _hoisted_2),
        (_ctx.timelineEntries.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_TransitionGroup, {
                name: 'timeline_list_' + _ctx.moveDirection
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineEntries.slice(_ctx.min, _ctx.max), (entry, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: entry.id,
                      style: _normalizeStyle(_ctx.elementsWidth),
                      class: "d-flex h-100 justify-content-center timeline-entry"
                    }, [
                      _createVNode(_component_TimelineEntry, {
                        fullScreen: _ctx.fullScreen,
                        index: _ctx.canFetchAdditional() ? index + _ctx.min - 1 : index + _ctx.min,
                        entry: entry,
                        timeline: _ctx.timeline
                      }, null, 8, ["fullScreen", "index", "entry", "timeline"])
                    ], 4))
                  }), 128))
                ]),
                _: 1
              }, 8, ["name"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.showRight,
          class: "btn btn-secondary move-timeline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchRight()))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'angle-right'] })
        ], 8, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}